<template>
<div class="change">
  <el-container v-for="( groupitem , index) in dbList" :key='index'>
    <div class="group-wrap">
      <div class="head">{{groupitem.DbGroupName}}</div>
      <el-main class="db-wrap">
        <button v-for="(item,index) of groupitem.databasesList" @click="selectDb(item)" :key='index' 
          :class="{selected:db&&db.customerName==item.customerName?true:false,dbitem:true}">
        {{item.customerName}}
        </button>
      </el-main>
    </div>
  </el-container>
</div>
</template>

<script>
import { getListDb,testDb } from '@api/common';

export default {
  name: "changeFactory",
  data() {
    return {
      dbList:null, // 用户可选数据库列表
    };
  },
  created() {
    this.getListDb(); // 获取数据库列表
  },
  computed:{
    // 当前选择数据库
    db(){
      return this.$store.getters.db;
    }
  },
  methods:{
    /* 点击button,选择数据库 */
    async selectDb(item){
      // 测试数据库
      let data = await testDb(item.dburlname);
      if(data.status==200){
        // 更新vuex中的数据库
        this.$store.commit('db',item);
        // 同步获取用户配置信息和站点信息,并更新vuex里面的内容 
        this.$store.dispatch("getUserConfig").then(()=>{
          this.$router.push("/list/realTimeForm");
        });
      }else{
        this.$message({
          message:"数据库不可用",
          type:"error"
        })
      }
    },
    /* 首次进入页面获取数据库列表 */
    async getListDb(){
      let data =  await getListDb();
      this.dbList=data.content;
    },
  }
};   
</script>
<style lang="scss">
.change{
  .head{
    color:#4E84FF;
    font-size: 20px;
    padding:5px 20px;
  }
  button{
    border: 1px solid ;
    margin :  3px;
    width: 130pt;
    height: 30pt;
    border-radius: 5pt;
    background: white;
    cursor: pointer;
  }
  .group-wrap{
    width: 100%;
    background: white;
    margin: 10px;
  }
  .db-wrap{
    padding:10px;

    // 选中的数据库
    .selected{
      background:#4E84FF;
      color:#fff;
    }
  }
}

</style>